import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { spApi } from '../../api/serviceProviders';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      // Fetch both profile and dashboard stats simultaneously
      const [profileRes, dashRes] = await Promise.all([
        spApi.getProfile(),
        spApi.getDashboard().catch(() => ({ data: {} })) // fallback if dashboard endpoint fails
      ]);

      if (profileRes.success || profileRes.status === 800) {
        setProfile(profileRes.data?.provider || profileRes.data || {});
      }
      
      setDashboardData(dashRes?.data || {});
    } catch (err) {
      setError(err.message || 'Kuna tatizo limejitokeza wakati wa kupakia dashibodi.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center mt-5" style={{ minHeight: '300px' }}>
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      {error && <Alert variant="danger" className="mb-4">{error}</Alert>}
      <Card className="shadow-sm border-0 mb-4 overflow-hidden">
        {/* Profile Header / Wallpaper */}
        <div style={{
          height: '250px',
          backgroundColor: '#f8f9fa',
          backgroundImage: profile?.wallpaper?.lg_photo ? `url(${profile.wallpaper.lg_photo})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative'
        }}>
          {!profile?.wallpaper?.lg_photo && (
            <div className="d-flex align-items-center justify-content-center h-100 text-muted">
              <span>Picha ya jalada haijawekwa</span>
            </div>
          )}
        </div>

        <Card.Body className="p-4 position-relative">
          <div className="d-flex justify-content-between align-items-start mb-4">
            <div>
              <h3 className="mb-1">{profile?.name || 'Jina la Biashara'}</h3>
              <p className="text-muted mb-2">
                <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
                {profile?.location || 'Mahali hakujatajwa'}
              </p>
              <div className="d-flex flex-wrap gap-2 mt-2">
                {profile?.categories?.map((cat) => (
                  <span key={cat.id} className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill">
                    {cat.category}
                  </span>
                ))}
              </div>
            </div>
            <div className="text-end">
              <span className={`badge ${profile?.status === 1 ? 'bg-success' : 'bg-warning text-dark'} px-3 py-2 rounded-pill fs-6`}>
                {profile?.status === 1 ? 'Imeidhinishwa (Active)' : 'Inasubiri (Pending)'}
              </span>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Row>
        <Col md={4}>
          <Card className="mb-3 shadow-sm border-0 text-center">
            <Card.Body className="py-4">
              <h2 className="text-primary fw-bold">{dashboardData?.packages_count || 0}</h2>
              <Card.Title className="text-muted text-uppercase mb-0" style={{ fontSize: '0.9rem' }}>Packages</Card.Title>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-3 shadow-sm border-0 text-center">
            <Card.Body className="py-4">
              <h2 className="text-success fw-bold">{dashboardData?.photos_count || 0}</h2>
              <Card.Title className="text-muted text-uppercase mb-0" style={{ fontSize: '0.9rem' }}>Picha Zilizopakiwa</Card.Title>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-3 shadow-sm border-0 text-center">
            <Card.Body className="py-4">
              <h2 className="text-warning fw-bold">{dashboardData?.reviews_count || 0}</h2>
              <Card.Title className="text-muted text-uppercase mb-0" style={{ fontSize: '0.9rem' }}>Reviews</Card.Title>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
